<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="copy2">Copyright © 1995 by Ginu Kamani</p>
<p class="copy1">All rights reserved. This book, or parts thereof, must not be reproduced in any form without written permission from the publisher.</p>
<p class="copy1">First Edition</p>
<p class="copy">10 9 8 7 6 5 4 3</p>
<p class="copy1">Aunt Lute Books</p>
<p class="copy">PO Box 410687</p>
<p class="copy">San Francisco, CA 94141</p>
<p class="copy1">This book was funded in part by a grant from the National Endowment for the Arts. This is a work of fiction. In no way does it intend to represent any real person, living or dead, or any real incidents.</p>
<p class="copy">“Maria” and “Waxing The Thing” first appeared in <i>Our Feet Walk the Sky: Women of the South Asian Diaspora,</i> ed. The Women of South Asian Descent Collective (San Francisco: Aunt Lute Books, 1993).</p>
<p class="copy1">Cover Art: “Nayika” by Gogi Saroj Pal</p>
<p class="copy">Cover and Text Design: Pamela Wilson Design Studio</p>
<p class="copy">Typesetting: JBWiley, Drago Design</p>
<p class="copy1">Senior Editor: Joan Pinkvoss</p>
<p class="copy">Managing Editor: Christine Lymbertos</p>
<table>
<tbody><tr>
<td><p class="copy1">Production:</p></td>
<td><p class="copy1">Cristina Azócar<br/>Vita Iskandar</p></td>
<td><p class="copy1">Jee Yeun Lee<br/>Kathleen Wilkinson</p></td>
</tr>
<tr>
<td><p class="copy1">Production Support:</p></td>
<td><p class="copy1">Jonna K. Eagle<br/>Jamie Lee Evans<br/>Irma de Jesus</p></td>
<td><p class="copy1">Melissa Levin<br/>Michelle Uribe<br/>Alexa Weinstein</p></td>
</tr>
</tbody></table>
<p class="copy1">Printed in the U.S.A. on acid-free paper.</p>
<p class="copy1"><b>Library of Congress Cataloging-in-Publication Data</b></p>
<p class="copy1">Kamani, Ginu, 1962–</p>
<p class="copyi">Junglee Girl / by Ginu Kamani</p>
<p class="copyi">   p. cm.</p>
<p class="copyi">ISBN 1–879960–41–9 — ISBN 1–879960–40–0 (pbk.) — Ebook ISBN 978–1–939904–11–9</p>
<p class="copyi">1. Short Stories, Indic (English)    2. Social problems—Fiction.    3. Women—India—Social Life and customs—Fiction.    4. Women—India—Social conditions—Fiction.    5. United States—Social conditions—Fiction.      I. Title.</p>
<table width="100%">
<tbody><tr>
<td><p class="copyi">PR9497.32.K36    1995</p></td>
<td align="right"><p class="copyr">94-46891</p></td>
</tr>
<tr>
<td><p class="copyi">823—dc20</p></td>
<td align="right"><p class="copyr">CIP</p></td>
</tr>
</tbody></table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?0d102c21